import {
    DatePicker,
    LocalizationProvider
} from "@mui/x-date-pickers";
import {
    Stack,
    TextField
} from "@mui/material";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";

interface DateFilterProps {
    createdAtStartDateField: number | null;
    createdAtEndDateField: number | null;
    onDateChange: (from: number | null, to: number | null) => void;
}

export const DateFilter = (props: DateFilterProps) => {
    const {
        onDateChange,
        createdAtStartDateField,
        createdAtEndDateField
    } = props;

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <LocalizationProvider
                dateAdapter={AdapterDateFns}
            >
                <DatePicker
                    disableFuture
                    label="From"
                    value={createdAtStartDateField}
                    onChange={(newValue) => onDateChange(newValue, createdAtEndDateField)}
                    slotProps={{
                        textField: { size: "small" }
                    }}
                />
                <DatePicker
                    disableFuture
                    label="To"
                    value={createdAtEndDateField}
                    onChange={(newValue) => onDateChange(createdAtStartDateField, newValue)}
                    slotProps={{
                        textField: { size: "small" }
                    }}
                />
            </LocalizationProvider>
        </Stack>
    );
};
